// Groups inline-quote replies (message.replyToId) directly under their
// target message in display order, so they render nested/indented in the
// same flat feed instead of a separate thread panel. Depth is collapsed to
// a single boolean (`isReply`) since the UI only needs one indent level.
export function buildReplyTree(messages) {
  const byId = {};
  messages.forEach((m) => { byId[m.id] = m; });
  const childrenOf = {};
  const topLevel = [];
  messages.forEach((m) => {
    if (m.replyToId && byId[m.replyToId] && m.replyToId !== m.id) {
      (childrenOf[m.replyToId] = childrenOf[m.replyToId] || []).push(m);
    } else {
      topLevel.push(m);
    }
  });
  const ordered = [];
  const walk = (m, depth) => {
    ordered.push({ msg: m, isReply: depth > 0 });
    (childrenOf[m.id] || []).forEach((c) => walk(c, depth + 1));
  };
  topLevel.forEach((m) => walk(m, 0));
  return ordered;
}
